import { render, staticRenderFns } from "./EcodopplerArtiInferioriEditComponent.vue?vue&type=template&id=10c9e7eb&scoped=true"
import script from "./EcodopplerArtiInferioriEditComponent.vue?vue&type=script&lang=js"
export * from "./EcodopplerArtiInferioriEditComponent.vue?vue&type=script&lang=js"
import style0 from "./EcodopplerArtiInferioriEditComponent.vue?vue&type=style&index=0&id=10c9e7eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c9e7eb",
  null
  
)

export default component.exports